<style scoped>
    .header-item{
        display: inline-block;
        vertical-align: middle;
    }
    .account{
        cursor: pointer;
        color: #9ba7b5;
    }
</style>
<template>
  <div class="header-item">
    <Dropdown
      transfer
      trigger="click"
      placement="bottom-end"
      @on-click="itemClick"
    >
      <span class="account">
        {{ customer_account }}
        <Icon type="arrow-down-b" />
      </span>
      <DropdownMenu slot="list">
        <DropdownItem name="customer-detail">
          个人信息
        </DropdownItem>
        <DropdownItem
          name="logout"
          divided
        >
          退出
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
</template>
<script>
  import Util from '../../../libs/util';
  import host from '@/config/host.js'
  export default {
    data() {
      return {
        //
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      customer_account() {
        return this.cur_customer.account ? this.cur_customer.account : '获取登录信息...';
      },
    },
    created() {
      //
    },
    mounted() {
      //
    },
    methods: {
      itemClick(name) {
        switch (name) {
        case 'customer-detail':
          this.$router.push({path: '/mine/profile', query: { rt: new Date().getTime() }});
          break;
        case 'logout':
          // 跳往另一个链接
          window.location.href = host.logout;
          break; 
        default:
          console.warn('undefined action.');
          break;
        }
      }
    }
  }
</script>
